import React, {useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'

import Loading from '../../../../component/Loading/Loading';
import ByondGrid2 from "../../../../customGrid/CustomGrid";
import Notify from '../../../../services/Notify';
import {AlertService} from '../../../../services/AlertService';
import {dayMonthYearAtTimeWithSeconds} from '../../../../utils/dates';
import WrongWorkFlowGridDetailType from './WrongWorkFlowGridDetailType';
import {Link} from "react-router-dom";

function WrongWorkFlowDetailType({data, setCurrentDetailType}) {

  const alertService = new AlertService()

  if (!data) {
    return <p>Sem dados</p>;
  }
  const wrongWorkFlowItemItemGrid = new WrongWorkFlowGridDetailType(data)

  const [alertDetails, setAlertDetails] = useState(null)

  useEffect(() => {
    if (!alertDetails) {
      return
    }
    setCurrentDetailType({
      metadata: wrongWorkFlowItemItemGrid,
      endpoint: wrongWorkFlowItemItemGrid.endpoint()
    })
  }, [alertDetails])
  const getWrongWorkFlowData = async () => {
    try {
      const responseData = await alertService.getWrongWorkFlowAlert(data.id)
      setAlertDetails(responseData.content)
    } catch (error) {
      Notify.error('Houve um erro ao recuperar os dados do alerta', error)
    }
  }
  const mapToFriendlyName = (data) => {
    if (!data) {
      return 'Sem dados';
    }
    return data.map(x => <li key={x.id}>{x.friendlyName}</li>);
  }

  const SingleInformation = ({title, content, colSpace}) => {
    return (
      <Col md={colSpace || 6} className="mt-4">
        <h4 style={{fontWeight: 'bold'}}>{title}:</h4>
        <p>{content || 'Sem dados'}</p>
      </Col>
    )
  }

  const ListInformation = ({title, content, colSpace}) => {
    return (
      <Col md={colSpace || 6} className="mt-4">
        <h4 style={{fontWeight: 'bold'}}>{title}:</h4>
        <ul>{mapToFriendlyName(content)}</ul>
      </Col>
    )
  }
  useEffect(() => {
    getWrongWorkFlowData()
  }, [])
  return (
    !alertDetails ? <Loading/> :
      <React.Fragment>
        <Row>
          <SingleInformation
            title="ID da Transação"
            colSpace={4}
            content={<Link to={`/transactions/${alertDetails[0] && alertDetails[0].transactionItem.transactionIdInString}`}> {alertDetails[0] && alertDetails[0].transactionItem.transactionIdInString}  </Link>}
          />
          <SingleInformation
            title="Data da Transação"
            colSpace={4}
            content={alertDetails[0] && alertDetails[0].transactionItem && dayMonthYearAtTimeWithSeconds(alertDetails[0].transactionItem.createdAt)}
          />
          <SingleInformation
            title="Ponto de Controle"
            colSpace={4}
            content={alertDetails[0] && alertDetails[0].transactionItem && alertDetails[0].transactionItem.checkpoint && alertDetails[0].transactionItem.checkpoint.friendlyName}
          />
          <SingleInformation
            title="Disposição Destino"
            colSpace={4}
            content={alertDetails[0] && alertDetails[0].transactionItem && alertDetails[0].transactionItem.lsd && alertDetails[0].transactionItem && alertDetails[0].transactionItem.lsd.disposition.friendlyName}
          />
          <SingleInformation
            title="Etapa Destino"
            colSpace={4}
            content={alertDetails[0] && alertDetails[0].transactionItem && alertDetails[0].transactionItem.lsd && alertDetails[0].transactionItem && alertDetails[0].transactionItem.lsd.bizStep.friendlyName}
          />
          <SingleInformation
            title="Local Destino"
            colSpace={4}
            content={alertDetails[0] && alertDetails[0].transactionItem && alertDetails[0].transactionItem.lsd && alertDetails[0].transactionItem && alertDetails[0].transactionItem.lsd.bizLocation.friendlyName}
          />
          <ListInformation
            title="Disposições Permitidas"
            colSpace={4}
            content={alertDetails[0] && alertDetails[0].checkpointAllowed && alertDetails[0].checkpointAllowed.allowedDispositions}
          />
          <ListInformation
            title="Etapas Permitidas"
            colSpace={4}
            content={alertDetails[0] && alertDetails[0].checkpointAllowed && alertDetails[0].checkpointAllowed.allowedSteps}
          />
          <Col md={12}>
            <ByondGrid2 endpoint={wrongWorkFlowItemItemGrid.endpoint()} metadata={wrongWorkFlowItemItemGrid} removeBox/>
          </Col>
        </Row>
      </React.Fragment>
  )
}

export {WrongWorkFlowDetailType}



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/WrongWorkFlow/WrongWorkFlowDetailType.js